import classNames from 'classnames'
import Action from 'components/Action'
import style from 'components/IconStrip.module.scss'
import Pictograms from 'components/Pictograms'
import { motion } from 'framer-motion'
import { rootVariants, transitionDefaults } from 'lib/constants'
import { formatMarkdown } from 'lib/helpers'
import camelCase from 'lodash/camelCase'
import React from 'react'
import { useInView } from 'react-intersection-observer'

const IconStrip = ({ items, actionLabel, actionUrl }) => {
  const { ref, inView, entry } = useInView({
    triggerOnce: true,
  })

  const className = classNames(style.root)

  return (
    <motion.div
      className={className}
      ref={ref}
      variants={rootVariants}
      initial="initial"
      animate={inView ? 'animate' : 'initial'}
      exit="exit"
    >
      <div className={style.content}>
        <ul className={style.items}>
          {items.map((item, index) => {
            const Pictogram = Pictograms[camelCase(item.iconName)]

            return (
              <li key={item.id} className={style.item}>
                <div className={style.icon}>
                  <Pictogram key={item.iconName} />
                </div>
                <div className={style.caption}>
                  <h3 className={style.heading}>{item.title}</h3>
                  {!!item.text && (
                    <div
                      className={style.text}
                      dangerouslySetInnerHTML={{
                        __html: formatMarkdown(item.text?.text),
                      }}
                    />
                  )}
                </div>
              </li>
            )
          })}
        </ul>
        {actionUrl && actionLabel && (
          <div className={style.action}>
            <Action url={actionUrl} label={actionLabel} />
          </div>
        )}
      </div>
    </motion.div>
  )
}

export default IconStrip
